import React from "react"
import styles from "./index.module.scss"
import ContentWithSidebars from "../../components/templates/ContentWithSidebars"
import AccountSidebarNav from "../../components/AccountSidebarNav"
import NotificationsSettingsContainer from "../../containers/NotificationsSettingsContainer"
import services from "../../services"
import Loading from "../../components/Loading/Loading"

const NotificationsSettingsPage = () => {
  const [state, setState] = React.useState({ isLoading: true })

  React.useEffect(() => {
    services.accountServices.getAccountSettings().then(({ data }) => {
      setState({
        data,
        isLoading: false,
      })
    })
  }, [])

  const updateSettings = (data) =>
    new Promise((res, rej) =>
      services.accountServices
        .setAccountSettings(data)
        .then(({ data }) => {
          setState((prevState) => ({
            ...prevState,
            data,
            isLoading: false,
          }))
          res(data)
        })
        .catch(({ response }) => rej(response.data)),
    )

  const refreshSettings = () => {
    services.accountServices.getAccountSettings().then(({ data }) => {
      setState((prevState) => ({
        ...prevState,
        data,
        isLoading: false,
      }))
    })
  }

  return (
    <div className={styles.pageWrap}>
      <ContentWithSidebars topSidebar={() => <AccountSidebarNav />}>
        <div className={styles.settingsLayout}>
          <div className={styles.settingsContent}>
            {state.isLoading ? (
              <Loading />
            ) : (
              <>
                {state.data && (
                  <NotificationsSettingsContainer
                    data={state.data}
                    updateSettings={updateSettings}
                    refreshSettings={refreshSettings}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </ContentWithSidebars>
    </div>
  )
}

export default NotificationsSettingsPage

